var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumbs',{staticClass:"pa-0",attrs:{"items":_vm.breadcrumbs}})
}
var staticRenderFns = []

export { render, staticRenderFns }